import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import bugsnagClient from 'JS/global/bugsnag';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { computed } from 'vue';
import { IProductDetailProductJson } from 'JS/types/PDP';


export default /*#__PURE__*/_defineComponent({
  __name: 'PdpReviews',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
	product: IProductDetailProductJson;
}



const reviewsText = computed(() => {
	if (props.product.numReviews >= 1000) {
		const rounded = Math.floor(props.product.numReviews / 100) / 10; // round to 1 decimal place
		const formatted = rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);

		return `${formatted}K`;
	} else {
		return props.product.numReviews;
	}
});

const width = computed(() => {
	const roundedRating = Math.floor(props.product.avgRating * 2) / 2; //round down to nearest .5
	const widthPct = (roundedRating / 5) * 100;
	return `${widthPct}%`;
});

const starLabel = computed(() => {
	return `Rated ${props.product.avgRating} stars, ${props.product.numReviews} total reviews, scroll to reviews`;
});

function scrollToReviews() {
	const reviewRef = document.getElementById('pdpReviewsHeader');
	if (!reviewRef) return;

	const scrollTop = reviewRef.offsetTop - 130;

	//focus naturally scrolls, but we want specific placement for visual users.
	reviewRef.focus({ preventScroll: true });

	window.scrollTo({
		top: scrollTop,
		behavior: 'smooth',
	});

}

function showReviewModal() {
	//should be a harmless ignore, since we are checking the $BV does exist.
	//@ts-ignore
	if (!props.product.blainNumber || !window.$BV || !window.$BV.ui) {
		const err = 'Write review was clicked before bazaar voice was loaded';
		bugsnagClient.notify(err);
	} else {
		const productId = props.product.blainNumber;
		//@ts-ignore
		window.$BV.ui("rr", "submit_review", { productId });
	}
}


return { __sfc: true,props, reviewsText, width, starLabel, scrollToReviews, showReviewModal, BaseButton, Icon, LinkButton }
}

})